export default "__VITE_ASSET__kBVZKO5e__"